module.exports = __webpack_public_path__ + "static/img/王晨B.1a3f9348.png";